import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const detectBulkPurchaseIntentEnterpriseSalesHandoffAr: TemplateAr = {
  name: 'رصد نية الشراء بالجملة + تحويل لمبيعات المؤسسات',
  description:
    'الذكاء الاصطناعي يرصد إشارات الشراء المؤسسي ويوجّهها لفريق مبيعات المؤسسات المخوّل بتسعير مخصص.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: MessageSquare, label: 'إشارة مؤسسية' },
    { icon: Sparkles, label: 'رصد ذكي' },
    { icon: Users, label: 'توجيه مؤسسي', final: true },
  ],
  detailDescription: {
    paragraph1:
      'وجّه إشارة الشراء المؤسسي لفريق مبيعات المؤسسات فوراً، مو لأول مندوب يفضى. الـ AI يعرف طلب التسعير بالجملة، وشراء مقاعد متعددة، والوصول للـ API، ووثائق الامتثال، والعقود المخصصة، ومتطلبات SSO. والعميل المؤسسي ينتقل بمسار سريع لمندوب كبير مخوّل بتسعير وشروط مخصصة.',
    paragraph2:
      'الـ AI يكتب بيانات العميل المؤسسي وسياق المحادثة في الـ CRM عندك، ومعها تقدير حجم الصفقة ومؤشرات الاستعجال. ومندوبك يجيه تنبيه فوري مع ملخص تأهيل مؤسسي من الـ AI. والفرصة المؤسسية تتقدّم على الاستفسار العادي تلقائياً.',
  },
  benefits: [
    'تكسب عقود المؤسسات أسرع',
    'كل إشارة مؤسسية توصل لمندوب مخوّل بالتسعير',
    'مندوبك يدخل المحادثة والسياق كامل معه',
    'الفرص الأعلى قيمة تتقدّم الطابور',
    'دورة مبيعات المؤسسات تقصر',
    'معدل إغلاق الصفقات المؤسسية يرتفع',
  ],
};
